import { sonnerToast, dismissToast } from '@wellesley/system-toast/sonnerToast'
import { listenMessage } from '../../../common/message/listenMessage'
import {
  clickOnToastButtonAction,
  closeToastAction,
  showToastMessageAction,
  type ShowToastMessageAction,
  dismissToastAction,
  type DismissToastAction,
} from './actions'
import { sendIDMessage } from '../../../host/helpers/sendIDMessage'
import { type ID } from '../helpers/createIDAction'

const onClose = (id: ID) =>
  sendIDMessage({
    action: closeToastAction(id),
  })

const onClick = (id: ID) =>
  sendIDMessage({
    action: clickOnToastButtonAction(id),
  })

export const onDismiss = () =>
  listenMessage<DismissToastAction>({
    whitelist: [dismissToastAction],
    onMessage: ({ payload: { toastId } }) => {
      toastId && dismissToast(toastId)
    },
  })

export const onToastMessage = () =>
  listenMessage<ShowToastMessageAction>({
    whitelist: [showToastMessageAction],
    onMessage: ({ payload: { toast, options }, id }) => {
      sonnerToast({
        toast,
        options: {
          ...options,
          onAutoClose: () => onClose(id),
          onDismiss: () => onClose(id),
          ...(options?.actionButton && {
            actionButton: {
              label: options.actionButton.label,
              onClick: () => onClick(id),
            },
          }),
        },
      })
    },
  })
